/**
 * Created by User on 2019/8/28.
 */
import $ from 'jquery'

window.jQuery = $
window.$ = $
